// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1TjoK","full":"Card_full__1TNmf"};